// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list_items[data-v-368503b6]{background:#fff}.v-list-item[data-v-368503b6]:after{display:none}", ""]);
// Exports
module.exports = exports;
